'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys7 = require('babel-runtime/core-js/object/keys');

var _keys8 = _interopRequireDefault(_keys7);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unsubscribeFrom(k, subMap, subMapEntry) {
  subMapEntry[1].unsubscribe();
  return delete subMap[k];
} // Higher-order component that weaves in the current value of a collection of
// TC39 Observables into the props of the target component.


function subscribeTo(k, subMap, observable, component) {
  if (!observable) return;
  var subscription = observable.subscribe({
    next: function next(value) {
      return component.setState((0, _defineProperty3.default)({}, k, value));
    } });
  return subMap[k] = [observable, subscription];
}

function truthyFunction() {
  return true;
}

exports.default = function withPropsFromObservables(mapOfProps) {
  var shouldUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : truthyFunction;
  return function (NextComponent) {
    var withPropsFromObservables = function (_React$PureComponent) {
      (0, _inherits3.default)(withPropsFromObservables, _React$PureComponent);

      function withPropsFromObservables(props) {
        (0, _classCallCheck3.default)(this, withPropsFromObservables);

        var _this = (0, _possibleConstructorReturn3.default)(this, (withPropsFromObservables.__proto__ || (0, _getPrototypeOf2.default)(withPropsFromObservables)).call(this, props));

        _this.state = {};
        _this._subscriptionMap = {};

        return _this;
      }

      (0, _createClass3.default)(withPropsFromObservables, [{
        key: 'updateFromProps',
        value: function updateFromProps(props) {
          var observableMap = mapOfProps(props);
          var subscriptionMap = this._subscriptionMap;

          // For each observable in the new map...

          for (var _i4 = 0, _keys4 = (0, _keys8.default)(observableMap), _len4 = _keys4.length; _i4 < _len4; _i4++) {
            var _k = _keys4[_i4];
            var _observable = observableMap[_k];

            var _currentSub = subscriptionMap[_k];
            // If we are currently subscribed to the key...
            if (_currentSub) {
              // If the key is not mapped to the correct observable right now, unsubscribe
              if (_currentSub[0] !== _observable) {
                unsubscribeFrom(_k, subscriptionMap, _currentSub);
                subscribeTo(_k, subscriptionMap, _observable, this);
              }
            } // If mapped to the correct observable, do nothing.
            else {
                // We aren't subscribed to the key at all.
                subscribeTo(_k, subscriptionMap, _observable, this);
              }
          } // For each subscription...


          for (var _i5 = 0, _keys5 = (0, _keys8.default)(subscriptionMap), _len5 = _keys5.length; _i5 < _len5; _i5++) {
            var _k2 = _keys5[_i5];
            var _currentSub2 = subscriptionMap[_k2];

            // If not in the observableMap...
            if (!(_k2 in observableMap)) {
              // Unsubscribe.
              unsubscribeFrom(_k2, subscriptionMap, _currentSub2);
            }
          }
        }
      }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
          for (var _obj2 = this._subscriptionMap, _i6 = 0, _keys6 = (0, _keys8.default)(_obj2), _len6 = _keys6.length; _i6 < _len6; _i6++) {
            var _k3 = _keys6[_i6];
            var _currentSub3 = _obj2[_k3];

            unsubscribeFrom(_k3, this._subscriptionMap, _currentSub3);
          }
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          return this.updateFromProps(this.props);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (shouldUpdate(nextProps, this.props)) return this.updateFromProps(nextProps);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          return this.unsubscribeAll();
        }
      }, {
        key: 'render',
        value: function render() {
          var passedProps = (0, _assign2.default)({}, this.props, this.state);
          return _react2.default.createElement(NextComponent, passedProps);
        }
      }]);
      return withPropsFromObservables;
    }(_react2.default.PureComponent);

    return withPropsFromObservables;
  };
};